export const navigationItems = {
  firstLevel: [
    {
      link: "/",
      label: "Главная",
    },
    {
      link: "/users",
      label: "Пользователи",
      onlyVipRoles: true,
    },
    {
      link: "/login_history",
      label: "История входов",
      onlyVipRoles: true,
    },
  ],
  secondLevel: [
    {
      link: "/products",
      label: "Продукты",
    },
    {
      link: "/cut_of_clothes",
      label: "Крой",
    },
    {
      link: "/cloths",
      label: "Ткани",
    },
    {
      link: "/sewing_accessories",
      label: "Фурнитура",
    },
    {
      link: "/stationery",
      label: "Канцелярия",
    },
    {
      link: "/expendable_materials",
      label: "Расходники",
    },
    {
      link: "/packages",
      label: "Упаковки",
    },
    {
      link: "/promotional_products",
      label: "Рекламная продукция",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/_shared/constants/navigation.js